import API from "./axios";

export const getAttachments = (event_id) => {
  return API.get(`/rooms/events/attachments/`, {
    params: {
      event_id,
    },
  });
};
